"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Zoom = styled_components_1.default.div `
  transform: scale(${(props) => props.zoom});
  -moz-transform: scale(${(props) => props.zoom});
`;
const ZoomCertificate = (props) => {
    const design = props.design;
    const zoomCalculator = (maxTargetHeight, maxTargetWidth, previewHeight, previewWidth) => {
        let targetRatio = maxTargetWidth / maxTargetHeight;
        let previewRatio = previewWidth / previewHeight;
        if (targetRatio > previewRatio) {
            return maxTargetHeight / previewHeight;
        }
        else {
            return maxTargetWidth / previewWidth;
        }
    };
    (0, react_1.useEffect)(() => {
        const executeScripts = (html) => {
            // Script regex to extract script tags from html
            const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
            let match;
            while ((match = scriptRegex.exec(html)) !== null) {
                const scriptContent = match[1];
                const scriptElement = document.createElement("script");
                scriptElement.type = "text/javascript";
                scriptElement.text = scriptContent;
                document.body.appendChild(scriptElement);
            }
        };
        if (props.designHTML) {
            executeScripts(props.designHTML);
        }
        else if (design && design.preview) {
            executeScripts(design.preview);
        }
    }, [props.designHTML, design]);
    return !props.isBadge ? (react_1.default.createElement(Zoom, { style: {
            boxShadow: "0px 0px 6px #00000025",
            backgroundColor: "#ffffff",
            transformOrigin: props.designHTML ? "top left" : "",
        }, zoom: zoomCalculator(props.height, props.width, design ? design.heightPX : 566, design ? design.widthPX : 800), className: "notranslate" },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: props.designHTML ? props.designHTML : design.preview,
            } }))) : (react_1.default.createElement(Zoom, { zoom: zoomCalculator(props.height, props.width, design ? design.heightPX : 500, design ? design.widthPX : 500), style: {
            backgroundColor: "#ffffff",
            transformOrigin: props.designHTML ? "top left" : "",
        } },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: props.designHTML ? props.designHTML : design.preview,
            } })));
};
exports.default = ZoomCertificate;
